
import { Component, Vue, Emit, Mixins, Prop, Watch } from 'vue-property-decorator';
import { iDevice, iNetbar, iCommandOperate, eDispatchType, eStatus } from '../../../interface/result';
import {
  getMachines,
  delMachines,
  putAreaDetail,
  instructRequest,
  reloadData,
  patternEdit,
  repairEditData,
  getAreaDetailByAreaID,
  putDispatchType,
  setSwitchConfig,
  returnIndirect,
} from '@/api/deviceManaging';
import { GameArea } from '@/mixins/game_area';
import { PageQuery } from '@/mixins/page_query';
import Upload from './_Upload.vue';
import PopDetail from './_PopDetail.vue';
import DeviceDetailHook from './_DeviceDetailHook.vue';
import RepairDialgTip from './_RepairDialgTip.vue';
import { toast } from '../../../utils/common';
import LogUtils from 'panda-log';
import { eCommand } from '../../../interface/eCommand';
import { dispatch_status_config } from '../../../utils/config';

@Component({
  components: {
    Upload,
    PopDetail,
    DeviceDetailHook,
    RepairDialgTip,
  },
})
export default class DeviceDetail extends Mixins(GameArea, PageQuery) {
  @Prop() detailInfo!: iDevice;
  private detail: any = {};
  private oldDetail: any = {};
  private dragerVisible = false;
  private repairDialgTipVisible = false;
  private popVisible = false;
  private isEdit = false;
  private uuidValue = '';
  private query = {
    search: '',
    regionid: 0,
    is_public: 0,
    areaid: 0,
    status: -1,
  };

  private multipleSelection!: iDevice[];
  private deviceTable = [];
  private popObj!: iDevice;
  private removeIds: any[] = [];
  //刷新中
  refreshLoading: boolean = false;
  //进行操作中
  loading: boolean = false;
  dispathType = eDispatchType.OWN_DISPACTH;
  ownDispatch = eDispatchType.OWN_DISPACTH;
  publicDispatch = eDispatchType.PUBLIC_DISPACTH;
  unifyDispath = eDispatchType.UNIFY_DISPACTH;
  //唤醒操作
  await_behaviour: eCommand = eCommand.AWAKE;
  //重启操作
  restart_behaviour: eCommand = eCommand.RESTART;
  //关机操作
  close_behaviour: eCommand = eCommand.CLOSE;
  //维护操作
  repair_behaviour: eCommand = eCommand.REPAIR;
  //取消维护
  cancel_repair_behaviour: eCommand = eCommand.CANCEL_REPAIR;
  //删除操作
  delete_behaviour: eCommand = eCommand.DELETE;
  //删除操作
  returnValue: eCommand = eCommand.RETURN;
  dispatchType = [
    { id: eDispatchType.OWN_DISPACTH, name: '独立调度' },
    { id: eDispatchType.UNIFY_DISPACTH, name: '统一调度' },
    { id: eDispatchType.PUBLIC_DISPACTH, name: '共享调度' },
  ];
  tcpMode = [
    { id: 0, name: '仅普通tcp' },
    { id: 1, name: '该区支持BBR中转' },
  ];
  /* 状态 -1=全部 0=空闲 1=使用,2=离线,3=故障 4-维护 5-使用（暂停分配） */
  statusList = [
    {
      id: eStatus.NO,
      name: '全部',
    },
    {
      id: eStatus.FREE,
      name: '空闲',
    },
    {
      id: eStatus.OFFLINE,
      name: '离线',
    },
    {
      id: eStatus.MALFUCTIONED,
      name: '故障',
    },
    {
      id: eStatus.MAINTAIN,
      name: '维护',
    },
    {
      id: eStatus.USE,
      name: '使用',
    },
    {
      id: eStatus.USE_NO_ALLOT,
      name: '使用（暂停分配）',
    },
  ];
  webHookModel: any = {
    group: '',
    url: '',
    workable: [],
  };
  repairId: number[] = [];
  // webHookList: any = [];
  @Emit() goback() {}
  getTcpModelName(tcp_mode: number) {
    const info = this.tcpMode.find((item: any) => item.id == tcp_mode);
    return info ? info.name : '';
  }
  getUUID(uuid: string) {
    const len = uuid.length;
    this.uuidValue = uuid;

    if (len > 10) {
      this.uuidValue = uuid.substring(0, 5) + '*****' + uuid.substring(len - 5);
    }
  }
  updateUUID() {
    this.getUUID(this.detail.uuid);
  }
  /**
   * 处理下拉菜单的批量事件
   */
  handleBatch(command: iCommandOperate) {
    if (!this.removeIds.length) {
      toast('请勾选需要操作的设备', 'warning');
      return;
    }
    //删除
    if (command.id === 3) {
      this.batRemove();
      return;
    }
    //退还
    if (command.id === 6) {
      this.returnRow();
      return;
    }
    //批量维护
    if (command.id === this.repair_behaviour) {
      // console.log(this.removeIds);
      // this.repair(this.removeIds);
      this.repairId = this.removeIds;
      this.repairDialgTipVisible = true;
      return;
    }
    //批量取消维护
    if (command.id === this.cancel_repair_behaviour) {
      // console.log(this.removeIds);
      this.cancle_repair(this.removeIds);
      return;
    }
    this.chargingModeEdit(command.id);
  }
  repair(ids: number[]) {
    this.$prompt('维护原因：', '确认执行此操作吗', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputPattern: /\S/,
      inputErrorMessage: '请输入维护原因', // inputValue
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          await this.deviceMaintain(ids, instance.inputValue, eCommand.REPAIR);
          // 再发送get请求表格数据
          this.getAllMachines();
          done();
          instance.confirmButtonLoading = false;
        } else if (action === 'cancel') {
          done();
        }
      },
    }).then(action => {});
  }
  cancle_repair(ids: number[]) {
    this.$msgbox({
      title: '确认执行此操作吗',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          await this.deviceMaintain(ids, '', eCommand.CANCEL_REPAIR);
          // 再发送get请求表格数据
          this.getAllMachines();
          done();
          instance.confirmButtonLoading = false;
        } else if (action === 'cancel') {
          done();
        }
      },
    }).then(action => {});
  }
  // 收费模式：体验、收费
  chargingModeEdit(id: number) {
    this.$msgbox({
      title: '确认修改吗',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          // 发送修改请求
          //is_free	number	非必须 1=免费，2=收费
          // config_id 1=标配，2=高配
          let is_free = 0;
          let config_id = 0;
          switch (id) {
            case 1:
              is_free = 1;
              break;
            case 2:
              is_free = 0;
              break;
            case 4:
              config_id = 2;
              break;
            case 5:
              config_id = 1;
              break;
            case 7:
              config_id = 4;
              break;
          }
          if (id == 1 || id == 2) {
            await this.patternEditBatch({ ids: this.removeIds, is_free });
          } else if (id == 4 || id == 5 || id == 7) {
            await this.setSwitchConfig({ ids: this.removeIds, config_id });
          }
          done();
          instance.confirmButtonLoading = false;
        } else if (action === 'cancel') {
          done();
        }
      },
    }).then(action => {
      // this.$message({
      //   type: 'success',
      //   message: '修改成功',
      // });
    });
  }

  handleRepair(type: number) {
    this.repairDialgTipVisible = false;
    this.$prompt('维护原因：', '确认执行此操作吗', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputPattern: /\S/,
      inputErrorMessage: '请输入维护原因', // inputValue
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          await this.deviceMaintain(this.repairId, instance.inputValue, type);
          // 再发送get请求表格数据
          this.getAllMachines();
          done();
          instance.confirmButtonLoading = false;
        } else if (action === 'cancel') {
          done();
        }
      },
    }).then(action => {});
  }
  /**
   * 处理下拉菜单的事件
   */
  handleCommand(command: iCommandOperate) {
    if (command.type == eCommand.REPAIR) {
      // this.repairType = eCommand.REPAIR;
      this.repairId = [command.id];
      this.repairDialgTipVisible = true;
      return;
    }
    if (command.type == eCommand.CANCEL_REPAIR) {
      this.cancle_repair([command.id]);
      return;
    }
    this.$msgbox({
      title: '确认执行此操作吗',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          switch (command.type) {
            case eCommand.AWAKE:
            case eCommand.RESTART:
            case eCommand.CLOSE:
            case eCommand.REPAIR:
            case eCommand.CANCEL_REPAIR:
              this.instruct(command);
              break;
            case eCommand.DELETE:
              // this.removeRow([command.id]);
              await this.delPopRow([command.id]);
              // 再发送get请求表格数据
              this.getAllMachines();
              break;
          }
          done();
          instance.confirmButtonLoading = false;
        } else if (action === 'cancel') {
          done();
        }
      },
    }).then(action => {});
  }
  /**
   * 操作设备的状态
   */
  async instruct(command: iCommandOperate) {
    this.loading = true;
    try {
      await instructRequest(command.id, command.type);
      this.getAllMachines();
      toast('操作成功');
    } catch (error) {
      LogUtils.warn('error', error);
    } finally {
      this.loading = false;
    }
  }

  /**
  刷新数据
   */
  async refreshData() {
    try {
      this.refreshLoading = true;
      await reloadData();
      this.getAllMachines();
    } catch (error) {
      toast('刷新数据失败', 'warning');
    } finally {
      this.refreshLoading = false;
    }
  }

  batAdd() {
    this.dragerVisible = true;
  }
  async batRemove() {
    this.removeRow(this.removeIds);
  }

  handleUpload() {
    // console.log('上传了');
  }
  handleEdit() {
    this.getAllMachines();
    this.cancelEit();
  }

  cancelUpload() {
    this.dragerVisible = false;
    this.getAllMachines();
  }

  cancelEit() {
    this.popVisible = false;
  }

  cancel() {
    this.detail = JSON.parse(JSON.stringify(this.oldDetail));
    this.isEdit = false;
  }
  handleUpdateDetail() {
    this.oldDetail = JSON.parse(JSON.stringify(this.detail));
    this.isEdit = true;
  }
  searchList() {
    this.page_query.page = 1;
    this.getAllMachines();
  }
  // 重置
  ResetList() {
    this.query.search = '';
    this.page_query.page = 1;
    this.getAllMachines();
  }
  //格式化调度状态的显示
  formatterDispatchStatus(row: iDevice): string {
    return dispatch_status_config[row.dispath!];
  }
  showStatus(status: number) {
    if (status >= 0) {
      return this.statusList.filter(item => item.id === status)[0].name;
    }
    return '未知';
  }
  returnRow() {
    const h = this.$createElement;
    this.$msgbox({
      title: '确认退还吗',
      type: 'warning',
      message: h('p', undefined, [h('i', { style: 'color: red' }, '退还后不可恢复'), h('span', undefined, ' 你还要继续吗？ ')]),
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          // 发送删除请求
          await this.returnIndirect();
          done();
          instance.confirmButtonLoading = false;
        } else if (action === 'cancel') {
          done();
        }
      },
    }).then(action => {});
  }

  removeRow(ids: number[]) {
    const h = this.$createElement;
    this.$msgbox({
      title: '确认删除吗',
      type: 'warning',
      message: h('p', undefined, [h('i', { style: 'color: red' }, '删除后不可恢复'), h('span', undefined, ' 你还要继续吗？ ')]),
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          // 发送删除请求
          await this.delPopRow(ids);
          done();
          instance.confirmButtonLoading = false;
        } else if (action === 'cancel') {
          done();
        }
      },
    }).then(action => {
      this.$message({
        type: 'success',
        message: '删除成功',
      });
      // 再发送get请求表格数据
      this.getAllMachines();
    });
  }

  checkPopDetail(obj: iDevice) {
    if (obj) {
      this.popObj = obj;
    }
    this.popVisible = true;
  }

  handleSelectionChange(vals: iDevice[]) {
    this.multipleSelection = vals;
    if (vals.length > 1) {
      this.removeIds = [];
      vals.forEach((el: iDevice) => {
        this.removeIds.push(el.id);
      });
    } else if (vals.length === 0) {
      this.removeIds = [];
    } else {
      this.removeIds = [vals[0].id];
      // console.log('🧑🏻', this.removeIds);
    }
  }
  // 设备维护
  async deviceMaintain(ids: number[], remark: string, type: number) {
    try {
      let objStr: object[] = [];
      ids.forEach(item => {
        const newItem = { id: item, remark: remark, type: type };
        objStr.push(newItem);
      });
      const res = await repairEditData(objStr);
      if (res && res.code == 0) {
        toast('修改成功');
      } else {
        toast(res.msg, 'error');
      }
    } catch (error) {
      console.log(error);
    }
  }
  // 退还
  async returnIndirect() {
    try {
      const machines = this.multipleSelection.map(item => {
        return { host_id: item.id, config_id: item.config_id, machine: item.seq };
      });

      const res = await returnIndirect({
        uuid: this.detail.uuid,
        machines: machines,
      });
      if (res && res.code == 0) {
        toast('修改成功');
      } else {
        toast(res.msg, 'error');
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.getAllMachines();
    }
  }
  confirmEdit() {
    //验证

    if (!this.detail.uuid) {
      toast('UUID不能为空', 'error');
      return;
    }
    if (!this.detail.wss) {
      toast('wss中转地址不能为空', 'error');
      return;
    }
    if (!this.detail.wan) {
      toast('外网IP不能为空', 'error');
      return;
    }

    // if (this.dispathType != this.ownDispatch) {
    //   if (!this.detail.free_pool_id) {
    //     toast('体验服不能为空', 'error');
    //     return;
    //   }
    //   if (!this.detail.high_pool_id) {
    //     toast('高配服不能为空', 'error');
    //     return;
    //   }
    //   if (!this.detail.low_pool_id) {
    //     toast('标配服不能为空', 'error');
    //     return;
    //   }
    // }
    const webHook = this.detail.webhook;
    if (this.detail.webhook.length > 0) {
      let str = '';
      webHook.forEach((item: any, index: number) => {
        if (item.group === '' || item.url === '' || item.workable.length <= 0) {
          str += '钉钉群组:第' + (index + 1) + '项有信息没有填写！';
        }
      });
      if (str != '') {
        toast(str, 'error');
        return;
      }
    }
    this.updateContactInfo();
    // 再发送一个PUT
  }
  async updateContactInfo() {
    try {
      this.loading = true;
      const isp = this.detailInfo.isp;
      this.detail.isp = isp;
      const res = await putAreaDetail(this.detail);
      let resDispatchType;
      let isUpdateDispatch = this.dispathType != this.ownDispatch;
      if (isUpdateDispatch) {
        const { dispatch_type, low_pool_id, high_pool_id, free_pool_id, lux_pool_id, id, port_mapping_prefix } = this.detail;
        resDispatchType = await putDispatchType({ id, dispatch_type, low_pool_id, high_pool_id, free_pool_id, lux_pool_id, port_mapping_prefix });
      }
      if (res && res.code === 0) {
        if (isUpdateDispatch) {
          if (resDispatchType && resDispatchType.code === 0) {
            this.saveSuccess();
          } else {
            toast(resDispatchType.msg, 'error');
          }
        } else {
          this.saveSuccess();
        }
      } else {
        toast(res.msg, 'error');
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }
  saveSuccess() {
    this.isEdit = false;
    this.getAreInfo(); //得的header详情
    toast('操作成功');
  }
  async delPopRow(ids: number[]) {
    try {
      const res = await delMachines(ids);
    } catch (error) {
      console.log(error);
    }
  }

  async getAllMachines() {
    this.loading = true;
    try {
      const res = await getMachines({ ...this.query, ...this.page_query });
      if (res) {
        this.deviceTable = res.data.list;
        this.total = res.data.total;
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }
  // 批量修改收费模式
  async patternEditBatch(date: any) {
    try {
      const res: any = await patternEdit(date);
      if (res.code == 0) {
        toast('操作成功！');
        this.getAllMachines();
      } else {
        toast('操作失败！', 'error');
      }
    } catch (error) {
      console.log(error);
    }
  }
  // 批量修改高低配
  async setSwitchConfig(date: any) {
    try {
      const res: any = await setSwitchConfig(date);
      if (res.code == 0) {
        toast('操作成功！');
        this.getAllMachines();
      } else {
        toast('操作失败！', 'error');
      }
    } catch (error) {
      console.log(error);
    }
  }
  // created() {
  //   this.detail = JSON.parse(JSON.stringify(this.detailInfo));
  // }
  async getAreInfo() {
    const res = await getAreaDetailByAreaID({ area_id: this.detailInfo.id });
    this.detail = res.data;
    // this.webHookList = JSON.parse(JSON.stringify(this.detail.webhook));
    this.dispathType = this.detail.dispatch_type;
    if (this.detail.uuid) {
      this.getUUID(this.detail.uuid);
    }
  }
  handleAddWebHook() {
    this.detail.webhook.push(JSON.parse(JSON.stringify(this.webHookModel)));
  }
  handleDelWebHook(index: number) {
    this.detail.webhook.splice(index, 1);
  }
  mounted() {
    if (this.detailInfo.region_id && this.detailInfo.id) {
      this.query.regionid = this.detailInfo.region_id;
      this.query.areaid = this.detailInfo.id;
    }
    this.getAreInfo(); //得的header详情
    // if (this.detailInfo.uuid) {
    //   this.getUUID(this.detailInfo.uuid);
    //   this.dispathType = this.detail.dispatch_type;
    // }
    this.pageFn = this.getAllMachines;
    this.getAllMachines();
  }
}
